(function () {
  function init(root) {
    if (!root || root.dataset.smReady === 'true') return;
    root.dataset.smReady = 'true';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.classList.add('sm-js');

    var mediaFrame = root.querySelector('[data-sm-look-media]');
    var motionImage = root.querySelector('[data-sm-look-motion-image]');
    var video = root.querySelector('[data-sm-look-video]');
    var toggle = root.querySelector('[data-sm-video-toggle]');
    var pauseIcon = root.querySelector('[data-sm-pause-icon]');
    var playIcon = root.querySelector('[data-sm-play-icon]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sm-look-tab]'));
    var indexEl = root.querySelector('[data-sm-look-index]');
    var countEl = root.querySelector('[data-sm-look-count]');
    var titleEl = root.querySelector('[data-sm-look-title]');
    var descriptionEl = root.querySelector('[data-sm-look-description]');
    var linkEl = root.querySelector('[data-sm-look-link]');
    var productEls = Array.prototype.slice.call(root.querySelectorAll('[data-sm-look-product]'));
    var sectionVisible = false;
    var manuallyPaused = reduceMotion;
    var currentType = 'image';
    var imageIsPlaying = false;

    function setImagePlayback(shouldPlay) {
      if (!motionImage) return;
      var motionSource = motionImage.dataset.motionSrc || '';
      var posterSource = motionImage.dataset.posterSrc || '';
      var targetSource = shouldPlay ? motionSource : posterSource;

      if (targetSource && motionImage.getAttribute('src') !== targetSource) {
        motionImage.setAttribute('src', targetSource);
      }

      imageIsPlaying = Boolean(shouldPlay && motionSource);
    }

    function currentPaused() {
      if (currentType === 'image') return !imageIsPlaying;
      return !video || video.paused;
    }

    function updateToggle() {
      if (!toggle) return;
      var paused = currentPaused();
      toggle.setAttribute('aria-label', paused ? 'Play motion' : 'Pause motion');
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (pauseIcon) pauseIcon.hidden = paused;
      if (playIcon) playIcon.hidden = !paused;
    }

    function pauseCurrent() {
      if (currentType === 'image') {
        setImagePlayback(false);
      } else if (video) {
        video.pause();
      }
      updateToggle();
    }

    function safePlay() {
      if (manuallyPaused || !sectionVisible || reduceMotion) {
        pauseCurrent();
        return;
      }

      if (currentType === 'image') {
        setImagePlayback(true);
        updateToggle();
        return;
      }

      if (!video) return;
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {});
      }
      window.setTimeout(updateToggle, 50);
    }

    function revealMedia() {
      if (!mediaFrame) return;
      window.setTimeout(function () {
        mediaFrame.classList.remove('is-changing');
      }, 220);
    }

    function changeLook(tab) {
      if (!tab) return;

      if (mediaFrame) mediaFrame.classList.add('is-changing');
      pauseCurrent();

      tabs.forEach(function (item) {
        item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
      });

      if (indexEl) indexEl.textContent = tab.dataset.index || '';
      if (countEl) countEl.textContent = tab.dataset.count || '';
      if (titleEl) titleEl.textContent = tab.dataset.title || '';
      if (descriptionEl) descriptionEl.textContent = tab.dataset.description || '';
      if (linkEl) linkEl.setAttribute('href', tab.dataset.link || '/collections');

      var products = (tab.dataset.products || '').split('|');
      productEls.forEach(function (item, position) {
        item.textContent = products[position] || '';
        item.hidden = !products[position];
      });

      currentType = tab.dataset.type === 'video' ? 'video' : 'image';

      if (currentType === 'image') {
        if (video) {
          video.pause();
          video.hidden = true;
          video.removeAttribute('src');
          video.load();
        }

        if (motionImage) {
          motionImage.hidden = false;
          motionImage.dataset.motionSrc = tab.dataset.motion || '';
          motionImage.dataset.posterSrc = tab.dataset.poster || '';
          motionImage.setAttribute('alt', tab.dataset.aria || 'Styled footwear look');
          setImagePlayback(!manuallyPaused && sectionVisible && !reduceMotion);
        }

        revealMedia();
        updateToggle();
        return;
      }

      if (motionImage) {
        setImagePlayback(false);
        motionImage.hidden = true;
      }

      if (video) {
        video.hidden = false;
        video.setAttribute('aria-label', tab.dataset.aria || 'Styled footwear look video');
        if (tab.dataset.poster) video.setAttribute('poster', tab.dataset.poster);

        var nextSource = tab.dataset.video || '';
        if (nextSource && video.getAttribute('src') !== nextSource) {
          video.setAttribute('src', nextSource);
          video.load();
          video.addEventListener('loadeddata', function () {
            revealMedia();
            safePlay();
          }, { once: true });
          window.setTimeout(revealMedia, 1100);
        } else {
          revealMedia();
          safePlay();
        }
      }

      updateToggle();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        changeLook(tab);
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (currentPaused()) {
          manuallyPaused = false;
          safePlay();
        } else {
          manuallyPaused = true;
          pauseCurrent();
        }
      });
    }

    if (video) {
      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);
    }

    if (mediaFrame && 'IntersectionObserver' in window) {
      var mediaObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sectionVisible = entry.isIntersecting;
          if (sectionVisible) safePlay();
          else pauseCurrent();
        });
      }, { threshold: 0.28 });

      mediaObserver.observe(mediaFrame);
    } else {
      sectionVisible = true;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseCurrent();
      else safePlay();
    });

    var revealItems = Array.prototype.slice.call(root.querySelectorAll('[data-sm-reveal]'));

    if (!reduceMotion && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      });

      revealItems.forEach(function (item) {
        revealObserver.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    var selectedTab = tabs.filter(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0];

    if (selectedTab) changeLook(selectedTab);
    updateToggle();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-sm-home-refresh]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
